/** Match the engine's ordering; a non-skip stop can bypass later system safety rules. */
export function unsafeRuleStops(rules) {
  const ordered = [...rules].sort(
    (a, b) =>
      (a.priority ?? 1000) - (b.priority ?? 1000) ||
      String(a.id).localeCompare(String(b.id))
  );
  return ordered.flatMap((rule, index) => {
    const systemRules = ordered
      .slice(index + 1)
      .filter(r => r.system && r.enabled !== false);
    return rule.enabled !== false &&
      rule.stopProcessing &&
      !(rule.actions || []).some(a => a.type === 'skip') &&
      systemRules.length
      ? [{ rule, systemRules }]
      : [];
  });
}
